//changed due to package upgrade
import React from 'react';
import { Divider, Grid } from '@mui/material';
import AppGridContainer from '@projectK/components/AppGridContainer';
import { ChangePassword, Notification } from '@projectK/modules/MyProfile';
import PropTypes from 'prop-types'; // Import PropTypes
import {
  useRolePermissions,
  hasPermission,
} from '@projectK/context/RolesProvider';
import { useMobileSettings } from '@projectK/context/MobileContextProvider';
import ProfileinfoCard from '../ProfileInfoCard';

const SettingsPage = ({ isLogoNeed }) => {
  const { isMobile } = useMobileSettings();
  const { rolePermissions } = useRolePermissions();
  return (
    <div
      className='locker-page2'
      style={{ marginBottom: isMobile ? '50px' : '0px' }}
    >
      {isMobile ? null : (
        <>
          {isLogoNeed !== false && <ProfileinfoCard />}
          <Divider
            sx={{
              marginTop: 4,
              marginBottom: 5,
            }}
          />
        </>
      )}

      <AppGridContainer>
        {hasPermission(rolePermissions, 'My Locker - Settings', 'read') && (
          <Grid  size={{ xs: 12, md: 12,lg: 12,  }}>
            <Notification />
          </Grid>
        )}

        {hasPermission(rolePermissions, 'My Locker - Settings', 'read') && (
          <Grid  size={{ xs: 12, md: 12,lg: 12,  }}>
            <ChangePassword />
          </Grid>
        )}
      </AppGridContainer>
    </div>
  );
};
// Add PropTypes validation
SettingsPage.propTypes = {
  isLogoNeed: PropTypes.bool,
};

export default SettingsPage;
